import { BTSalesOrderUpdateRequestModel } from 'src/app/shared/models/request/salesorder-update-request-model-brightree';

export class AppointmentCancelRequest {
  schAppointmentId: number;
  schCancelReason: string;
  schComments: string;
  voidFrom: string;
  smsTextNumber?: string;
  crmSalesOrderId: number;
  crmSalesorderAppId?: string;
  modifiedByUserInfoId: number;
  SalesOrderStatus?: string;
  isProvisional: boolean;
  isCancelledByPatient: boolean;
  transactionID?: string;
  isGroupAppointment: boolean;
  groupAppointmentId?: number;
  salesOrderUpdateRequestModelBT: BTSalesOrderUpdateRequestModel;
}

